import Vue from 'vue'
import Home from './../screens/Home'
import Questionnary from "../screens/Questionnary";
import Router from 'vue-router'
import MajAndNews from "../screens/MajAndNews";

import Study from "../screens/Study";
import NotFound from "../screens/NotFound";
import Content from "../screens/Content";
import Studies from "../screens/Studies";
import Actualite from "../screens/Actualite";

import qs from 'qs'

Vue.use(Router)

// helper so anyone can use: <router-link @click.native="$scrollToTop">
Vue.prototype.$scrollToTop = () => window.scrollTo(0,0);

export default new Router({
    mode: "history",
    routes: [
        { 
            path: '/',
            name: 'home',
            component: Home,
        },
        {
            path: '/recommandation/:pathology',
            name: 'recommendation_pathology',
            component: Questionnary
        },
        {
            path: '/actualites/:pathologie?',
            component: MajAndNews,
            meta: { scrollToTop: true }
        },
        {
            path: '/actualite/:slug',
            component: Actualite,
            meta: { scrollToTop: true }
        },
        {
            path: '/etudes/:pathologie?',
            component: Studies,
            meta: { scrollToTop: true }
        },
        {
            path: '/etude/:slug',
            component: Study,
            meta: { scrollToTop: true }
        },
        {
            path: '/info/:slug',
            component: Content,
            meta: { scrollToTop: true }
        },
        {
            path: '/*',
            component: NotFound
        },
        {
            path: '/not-found',
            name: 'not-found',
            component: NotFound
        }
    ],
    // set custom query resolver
    parseQuery(query) {
        // return qs.parse(query, { arrayLimit: 0 });
        return qs.parse(query);
    },
    stringifyQuery(query) {
        var result = qs.stringify(query);

        return result ? ('?' + decodeURI(result)) : '';
        // return result ? ('?' + result) : '';
    }
})